import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { capitalizeWords } from "../../../Utils";

const MutasiSimpUSP = (periode, data, namaBulan, tahun, jenisTransaksi) => {
  if (!data || data.length === 0) {
    alert("Tidak ada data untuk dicetak.");
    return;
  }

  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const loadImageAsDataURL = (url) => {
  return fetch(url)
    .then((res) => res.blob())
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        })
    );
};
  namaBulan = namaBulan || "Tidak Diketahui";
  tahun = tahun || "Tidak Diketahui";

  const judul = jenisTransaksi === "simpananpokok" 
    ? "Laporan Simpanan Pokok" 
    : "Laporan Simpanan Wajib";

  const drawHeader = (logoDataUrl) => {
  const logoX = 10;
  const logoY = 8;
  const logoSize = 18;
  const textX = logoX + logoSize + 3;

  if (logoDataUrl) {
    doc.addImage(
      logoDataUrl,
      "PNG",
      logoX,
      logoY,
      logoSize,
      logoSize
    );
  }

  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text("KPRI SRI REJEKI", textX, 14);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text("Jl. Donomulyo No.164 Kab. Malang", textX, 19);

  const lineY = logoY + logoSize + 3;

  doc.setLineWidth(0.3);
  doc.line(8, lineY, pageWidth - 8, lineY);

  const reportY = lineY + 7;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text(judul, pageWidth / 2, reportY, {
    align: "center",
  });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(
    `${namaBulan} ${tahun}`,
    pageWidth / 2,
    reportY + 6,
    {
      align: "center",
    }
  );

  return reportY + 10;
};
  const headers = jenisTransaksi === "simpananpokok"
    ? [[
        { content: "No", styles: { halign: "left" } },
        { content: "Nomor \nAnggota", styles: { halign: "center" } },
        { content: "Nama", styles: { halign: "left" } },
        { content: "Unit Kerja", styles: { halign: "left" } },
        { content: "Saldo Awal", styles: { halign: "center" } },
        { content: "Simpanan", styles: { halign: "center" } },
        { content: "Penarikan", styles: { halign: "center" } },
        { content: "Total Saldo", styles: { halign: "center" } }
      ]]
    : [[
        { content: "No", styles: { halign: "left" } },
        { content: "Nomor \nAnggota", styles: { halign: "center" } },
        { content: "Nama", styles: { halign: "left" } },
        { content: "Unit Kerja", styles: { halign: "left" } },
        { content: "Saldo Awal", styles: { halign: "center" } },
        { content: "Simpanan", styles: { halign: "center" } },
        { content: "Penarikan", styles: { halign: "center" } },
        { content: "Total Saldo", styles: { halign: "center" } }
      ]];

  const formatNumber = (num) => {
    return num === null || num === undefined || isNaN(num) ? "-" : parseFloat(num).toLocaleString("id-ID");
  };

  let totalSaldoAwal = 0;
  let totalSetoran = 0;
  let totalPenarikan = 0;
  let totalSaldoAkhir = 0;

  let tableData = data.map((item, index) => {
    const saldoAkhir = (item.saldoawal || 0) + (item.setoran || 0) - (item.penarikan || 0);
    totalSaldoAwal += item.saldoawal || 0;
    totalSetoran += item.setoran || 0;
    totalPenarikan += item.penarikan || 0;
    totalSaldoAkhir += saldoAkhir;

    return [
      { content: index + 1, styles: { halign: "right" } }, 
      { content: item.noanggota ?? "-", styles: { halign: "right" } },
      capitalizeWords(item.nama),
      capitalizeWords(item.unitkerja),
      { content: formatNumber(item.saldoawal), styles: { halign: "right" } },
      { content: formatNumber(item.setoran), styles: { halign: "right" } },
      { content: formatNumber(item.penarikan), styles: { halign: "right" } },
      { content: formatNumber(saldoAkhir), styles: { halign: "right" } }
    ];
  });

  tableData.push([
    { 
      content: "Total Keseluruhan", 
      colSpan: 4, 
      styles: { 
        fontStyle: "bold", 
        halign: "center", 
        fillColor: [230, 230, 230], 
      } 
    }, 
    { 
      content: formatNumber(totalSaldoAwal), 
      styles: { 
        fontStyle: "bold", 
        halign: "right", 
        fillColor: [230, 230, 230], 
      } 
    }, 
    { 
      content: formatNumber(totalSetoran), 
      styles: { 
        fontStyle: "bold", 
        halign: "right", 
        fillColor: [230, 230, 230],
      } 
    }, 
    { 
      content: formatNumber(totalPenarikan), 
      styles: { 
        fontStyle: "bold", 
        halign: "right", 
        fillColor: [230, 230, 230], 
      } 
    },
    { 
      content: formatNumber(totalSaldoAkhir), 
      styles: { 
        fontStyle: "bold", 
        halign: "right", 
        fillColor: [230, 230, 230], 
      } 
    }  
  ]);

 const renderTable = (startY) => {
  autoTable(doc, {
    head: headers,
    body: tableData,
    startY: startY,
    theme: "grid",

    styles: {
      fontSize: 8,
      cellPadding: 1.5,
      overflow: "linebreak",
    },

    headStyles: {
      halign: "center",
      valign: "middle",
      fontSize: 8,
      cellPadding: 2,
      fillColor: [0, 191, 165],
      textColor: 255,
      fontStyle: "bold",
    },

    showHead: "everyPage",

    margin: {
      left: 8,
      right: 8,
      top: 20,
      bottom: 10,
    },

    tableWidth: "stretch",

    columnStyles: {
      0: {
        cellWidth: 10,
        halign: "right",
      },
      1: {
        cellWidth: 22,
        halign: "center",
      },
      2: {
        cellWidth: 42,
        halign: "left",
      },
      3: {
        cellWidth: 35,
        halign: "left",
      },
      4: {
        cellWidth: 22,
        halign: "right",
      },
      5: {
        cellWidth: 22,
        halign: "right",
      },
      6: {
        cellWidth: 22,
        halign: "right",
      },
      7: {
        cellWidth: 25,
        halign: "right",
      },
    },

    didDrawPage: (data) => {
      doc.setFontSize(8);

      doc.text(
        `Page ${doc.internal.getNumberOfPages()}`,
        data.settings.margin.left,
        doc.internal.pageSize.height - 10
      );
    },
  });

  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  window.open(pdfUrl, "_blank");
};
const customLogoUrl = "/koperasihitamputih.png";

loadImageAsDataURL(customLogoUrl)
  .then((logoDataUrl) => {
    const startY = drawHeader(logoDataUrl);
    renderTable(startY);
  })
  .catch((err) => {
    console.warn("Logo tidak ditemukan:", err);

    const startY = drawHeader();
    renderTable(startY);
  });
};

export default MutasiSimpUSP;